import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(
  state: RootState['currentArticleId'] = null,
  action: Action,
): RootState['currentArticleId'] {
  switch (action.type) {
    case 'SET_CURRENT_ARTICLE_ID':
      return action.payload
    default:
      return state
  }
}
